import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Dataset } from "../_types/dataset";
import { DatasetField } from "../_types/dataset-field";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
    providedIn: 'root',
})

export class DatasetsFieldsService extends Service<DatasetField> {
  public override type = 'datasetFields';
  public override url = 'reporting/datasetFields'; 

  getDropdownOptions(datasetFielId: string,  filter: any = {}): Observable<any> {
    let url = this.getAPIUrl()+"/"+datasetFielId+"/dropdownSqloptions";
    return this.http.post<any>(url, filter);
  }  
}
